export default __webpack_public_path__ + "static/media/FiraSans-Bold.b2c1d356.ttf";